// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.show-image[data-v-4798c908] {
    cursor:pointer;
    max-height: 96vh;
}
.sticky[data-v-4798c908] {
    position: sticky;
    top: 0;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
